import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useLocalizedState } from '@treams/treams-hooks/useLocalizedState';
import * as graphql from '@treams/treams-network';

import { Button } from '../common/button/Button';
import { Modal } from '../common/Modal';
import { Popover } from '../common/Popover';
import { Label } from '../common/Text';
import { Input } from '../form/controls/Input';
import { AddIcon } from '../icons';
import { LibraryCategoryMutations } from './LibraryMutations';

export function CreateLibraryCategory<T>(props: {
	mutations: LibraryCategoryMutations<T>;
	onCreate: (category: T) => void;
}) {
	const { t } = useTranslation();

	const [visible, setVisible] = useState(false);
	const [name, setName] = useState<graphql.LocalizedString>([]);
	const [localizedName, setLocalizedName] = useLocalizedState(name, setName);

	const createCategory = props.mutations.createCategory;

	if (!createCategory) {
		return null;
	}

	return (
		<Popover.Target
			backdrop
			contents={
				<Modal width={400} height="auto">
					<Modal.Header title={t('settings.feedbackLibrary.createCategory.title')} />
					<Modal.Contents>
						<Label mb={2}>{t('settings.feedbackLibrary.createCategory.name.label')}:</Label>
						<Input value={localizedName} onChange={setLocalizedName} autoFocus />
					</Modal.Contents>
					<Modal.FormFooter
						onCancel={() => setVisible(false)}
						onSave={async () => {
							const category = await createCategory(name);
							props.onCreate(category);
							setName([]);
							setVisible(false);
						}}
					/>
				</Modal>
			}
			visible={visible}
		>
			<Button
				type="secondary"
				title={t('settings.feedbackLibrary.createCategory.button')}
				icon={<AddIcon />}
				onClick={() => setVisible(true)}
			/>
		</Popover.Target>
	);
}
